import React from 'react';
import clsx from 'clsx';

import { AmenitiesTooltip, AmenitiesType } from '@utils/types/amenities';
import { BaseComponentProps } from '@utils/types/baseComponents';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';

import { Ergonomic } from '@assets/icons';
import { icons } from '@assets/icons/amenities';

import styles from './styles.module.scss';
import { useIsMobile } from '@utils/hooks/useIsMobile';

type Props = {
  amenity: AmenitiesType;
  iconMode?: boolean;
} & BaseComponentProps;

AmenityComponent.defaultProps = {
  iconMode: false,
};

const getIcon = (amenity: AmenitiesType) => {
  return icons[amenity] ?? <Ergonomic />;
};

export function AmenityComponent(props: Props) {
  const { containerStyle, amenity, iconMode } = props;
  const isMobile = useIsMobile();

  if (iconMode) {
    return (
      <Tooltip
        placement={isMobile ? 'bottomLeft' : 'bottom'}
        overlay={
          <span className={styles.tooltip}>
            {AmenitiesTooltip[amenity as keyof typeof AmenitiesTooltip] ??
              amenity}
          </span>
        }
        overlayClassName="amenity-tooltip"
      >
        <div className={clsx([styles.hoverableContainer, containerStyle])}>
          {getIcon(amenity)}
        </div>
      </Tooltip>
    );
  }

  return (
    <div className={clsx([styles.amenitiesContainer, containerStyle])}>
      <div className={styles.icon}>{getIcon(amenity)}</div>
      <span className={styles.amenity}>{amenity.replace('_', ' ')}</span>
    </div>
  );
}
